export default "__VITE_ASSET__a431523d__"